module.exports = __webpack_public_path__ + "assets/img/lbg.b9a1b558.jpg";